<template>
    <span class="tag-container" :class="{'tag-container--small' : size === 'small'}">
        <span v-for="(tag,index) in tags" class="tag" :class="tag.tag">{{tag.name}}</span>
    </span>
</template>

<script>
    export default {
    	props: [
    		"categories",
            "size"
        ],
        data () {
    	    return {
                knownCategories: {
					798: {
						name: "Feature",
                        tag: "tag--feature"
                    },
                    808: {
						name: "News",
                        tag: "tag--news"
                    },
                    807: {
					    name: "Video",
                        tag: "tag--video"
                    },
                    809: {
						name: "Opinion",
                        tag: "tag--opinion"
                    },
                    810: {
						name: "Interview",
                        tag: "tag--interview"
                    },
                    811: {
						name: "Interview",
                        tag: "tag--update"
                    },
					812: {
						name: "Poem",
						tag: "tag--poem"
					},
					813: {
						name: "Photo",
						tag: "tag--photo"
					}
                }
            }
        },
        computed: {
    		tags () {
    			return (this.categories || []).reduce((carry,category) => {
                    if (this.knownCategories[category]) {
						let {name,tag} = this.knownCategories[category];
						if (carry.length === 0) {
							return carry.concat({
								name,
								tag: {
									'tag--first': true,
									[tag]: true
								}
							})
                        } else {
							return carry.concat({
								name,
								tag: {
									[tag]: true
								}
							})
                        }
                    }
    			},[])
            }
        }
    }
</script>

<style lang="scss">
    .tag-container {
        font-size: 1.2rem;
        &--small {
            font-size: .9rem;
        }
    }
    span.tag {
        color: white;
        padding: 1px 6px;
        margin-left: 5px;
        background-color: #9f9f9f;
        border-radius: 5px;
        border: 2px solid white;
        font-size: inherit;
        box-shadow: 0 0 8px 0 rgba(0,0,0,.4);
        &--first {
            margin-left: 0;
        }
        &--feature {
            background-color: #cb8710;
        }
        &--news {
            background-color: #547f3a;
        }
        &--interview {
            background-color: #1b87d0;
        }
        &--opinion {
            background-color: #dc3232;
        }
        &--update {
            background-color: #00a900;
        }
        &--video {
            background-color: #2a2a2a;
        }
        &--poem {
            background-color: #5aa1e3;
        }
        &--photo {
            background-color: #942dc1;
        }
    }
</style>


// WEBPACK FOOTER //
// tags.vue?1f22f89d